export { default } from './ScoredCardDetailsTotallySureTooltipBanner'
